import { CircularProgress, Divider } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Table, TableBody, TableCell, TableContainer, TableRow, IconButton, } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store/appStore';
import { STATUS } from '../../utils/status';
import { getQuestionAnalysis } from '../../redux/slices/config';
import { useParams } from 'react-router-dom';
import TableHeader from '../table/tableHeader';
import { TableCellBody } from '../table/tableCell';
import { useStyles } from '../../assets/styles/listTableStyle';

const QuestionReportDrawer = ({ drawer, setDrawer, selectedRow }: any) => {
    const [questionAnalysisDataLoading, setQuestionAnalysisDataLoading] = useState(false)
    const [data, setData] = useState<any>([])
    const { id } = useParams();
    const classes = useStyles();

    const getQuestionAnalysisStatus = useSelector((state: RootState) => state.config.getQuestionAnalysisStatus)
    const QuestionAnalysisData = useSelector((state: RootState) => state.config.QuestionAnalysisData)
    const dispatch = useDispatch<AppDispatch>()

    const headers = ["DIFFICULTY LEVEL", "NUMBER OF EXPERTS WHO ATTEMPTED", "CORRECT ANSWER RATE", "MOST COMMON WRONG ANSWER"];

    useEffect(() => {
        dispatch(getQuestionAnalysis({ project_id: id, question_id: selectedRow || '' }))
    }, [drawer, id, selectedRow])

    useEffect(() => {
        if (getQuestionAnalysisStatus === STATUS.PENDING) {
            setQuestionAnalysisDataLoading(true)
        }
        if (getQuestionAnalysisStatus === STATUS.SUCESS) {
            setQuestionAnalysisDataLoading(false)
            setData(QuestionAnalysisData)

        }
    }, [getQuestionAnalysisStatus])

    return (
        <div>
            <IconButton onClick={() => setDrawer(false)} sx={{ float: "right" }}>
                <CloseIcon sx={{ fontSize: "23px" }} />
            </IconButton>
            <div>
                <h1>Question Analysis</h1>
                <Divider style={{ paddingTop: "5px", width: "100%" }} />

            </div>
            <div>
                <div style={{ width: 870, padding: 1, marginTop: "2%" }}>
                    <TableContainer style={{ minHeight: '75px' }}>
                        <Table className={classes.tableContainer} aria-label="simple table">
                            <TableHeader headers={headers} />
                            <TableBody>
                                {getQuestionAnalysisStatus === STATUS.PENDING ? (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            <CircularProgress />
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    QuestionAnalysisData?.data.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">No analysis available</TableCell>
                                        </TableRow>
                                    ) : (
                                        QuestionAnalysisData?.data.map((row: any) => {
                                            console.log(row);
                                            return (
                                                <TableRow key={row.id} sx={{ "&:hover": { backgroundColor: "#f9f9f9" } }}>
                                                    <TableCellBody>{row.difficulty_level}</TableCellBody>
                                                    <TableCellBody>{row.num_experts_attempted}</TableCellBody>
                                                    <TableCellBody>{row.correct_answer_rate}</TableCellBody>
                                                    <TableCellBody>{row.most_common_wrong_answer || '-'}</TableCellBody>
                                                </TableRow>
                                            );
                                        })
                                    )

                                )}
                            </TableBody>

                        </Table>
                    </TableContainer>
                </div>

            </div>
        </div>
    )
}

export default QuestionReportDrawer